const InfoIcon = (props: React.ComponentProps<"svg">) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="2rem"
      height="2rem"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M13.1719 10.0251C14.734 8.65829 17.2666 8.65829 18.8287 10.0251C20.3908 11.392 20.3908 13.608 18.8287 14.9749C18.5568 15.2128 18.2556 15.4093 17.9351 15.5643C16.9409 16.0455 16.0003 16.8954 16.0003 18V19M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16ZM16 23H16.01V23.01H16V23Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoIcon;
